export default function searchFunctionality() {
  searchPlaceholder();
  searchField();
}

function searchPlaceholder() {
  const searchFields = document.querySelectorAll('.woocommerce-product-search .search-field');

  if (searchFields.length > 0) {
    const lang = document.documentElement.lang;

    searchFields.forEach((field) => {
      if (lang === 'sv-SE') {
        field.setAttribute('placeholder', 'Vad letar du efter?');
      } else if (lang === 'en-US') {
        field.setAttribute('placeholder', 'What are you looking for?');
      } else {
        field.setAttribute('placeholder', 'What are you looking for?');
      }
    });
  }
}

function searchField() {
  const searchButton = document.querySelector('.mobile-menu-header .search');
  const searchOverlay = document.querySelector('.mobile-search-overlay');
  if (searchButton && searchOverlay) {
    searchButton.addEventListener('click', function () {
      searchOverlay.classList.toggle('is-visible');
    });
    document.addEventListener('click', function (event) {
      if (!searchOverlay.contains(event.target) && !searchButton.contains(event.target)) {
        searchOverlay.classList.remove('is-visible');
      }
    });
    const closeButton = searchOverlay.querySelector('.close');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        searchOverlay.classList.remove('is-visible');
      });
    }
  }
}
